import { render, staticRenderFns } from "./cardmap.vue?vue&type=template&id=52076924&scoped=true&"
import script from "./cardmap.vue?vue&type=script&lang=js&"
export * from "./cardmap.vue?vue&type=script&lang=js&"
import style0 from "./cardmap.vue?vue&type=style&index=0&id=52076924&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52076924",
  null
  
)

export default component.exports